import { Controller } from "stimulus"
import $ from 'jquery';

export default class extends Controller {
  static targets = ['content', 'photo', 'previewPhoto', 'previewPhotoSection', 'file', 'previewFile', 'previewFileSection', 'submit', 'errorMessage', 'error']

  connect() {
    const photoTarget = this.photoTarget
    const fileTarget = this.fileTarget

    if ($(photoTarget).attr('value')) {
      this.showPhoto()
    }
    if ($(fileTarget).attr('value')) {
      const filename = $(fileTarget).data('name')

      $(this.previewFileTarget).text(filename)
      this.showFile()
    }
  }

  editPhotoHandler() {
    const file = this.photoTarget.files[0]

    if (file) {
      const photoPreview = this.previewPhotoTarget
      const reader = new FileReader()

      reader.onload = () => {
        photoPreview.src = reader.result
      }

      reader.readAsDataURL(file)
      this.setAttachments(this.photoTarget, 'photo', false)
      this.showPhoto()
    }
  }

  showPhoto() {
    $(this.previewPhotoSectionTarget).fadeIn(500)
  }

  removePhoto() {
    $(this.previewPhotoSectionTarget).fadeOut(200)
    this.previewPhotoTarget.src = ''
    $(this.photoTarget).attr('value', '')
    $(this.photoTarget).val('')
    this.setAttachments(this.photoTarget, 'photo', true)
  }

  fileHandler() {
    const file = this.fileTarget.files[0]

    if (file) {
      $(this.previewFileTarget).html(file.name)

      this.showFile()
      this.setAttachments(this.fileTarget, 'file', false)
    }
  }

  showFile() {
    $(this.previewFileSectionTarget).fadeIn(500)
  }

  removeFile() {
    $(this.previewFileSectionTarget).fadeOut(500)
    $(this.fileTarget).attr('value', '')
    $(this.fileTarget).attr('data-name', '')
    this.fileTarget.value = ''
    this.setAttachments(this.fileTarget, 'file', true)
  }

  setAttachments(target, type, removed) {
    $(target).attr(`data-${type}-removed`, removed)
  }

  createForm() {
    const authToken = $('input[name ="authenticity_token"]').val()
    const content = this.contentTarget.value
    const photo = this.photoTarget.files[0]
    const photoRemoved = $(this.photoTarget).attr('data-photo-removed')
    const file = this.fileTarget.files[0]
    const fileRemoved = $(this.fileTarget).attr('data-file-removed')
    const formData = new FormData()

    formData.append('community_post[socket_id]', window.socket.id)
    formData.append('authenticity_token', authToken)

    if (content) {
      formData.append('community_post[content]', content)
    }

    if (photo) {
      formData.append('community_post[photo]', photo)
    } else if (photoRemoved == 'true') {
      formData.append('community_post[remove_photo]', true)
    }

    if (file) {
      formData.append('community_post[file]', file)
    } else if (fileRemoved == 'true') {
      formData.append('community_post[remove_file]', true)
    }

    return formData
  }

  resetSubmit() {
    this.submitTarget.value = 'Save'
    $(this.submitTarget).prop('disabled', false)
  }

  resetForm() {
    this.element.reset()
    this.resetSubmit()
    this.errorMessageTarget.innerHTML = ''
    $(this.errorTarget).removeClass('has-error')
    this.removeFile()
    this.removePhoto()
  }

  submit(e) {
    e.preventDefault()
    const url = $(this.element).attr('action')
    const formData = this.createForm()

    $.ajax({
      type: 'PUT',
      url: url,
      data: formData,
      cache: false,
      contentType: false,
      processData: false,
      success: data => {
        this.resetForm()
      },
      error: data => {
        this.resetSubmit()
        this.errorMessageTarget.innerHTML = data.responseJSON.error
        $(this.errorTarget).addClass('has-error')
      }
    })
  }
}